import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TestHooks } from './parties.hooks';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-parties',
	templateUrl: './parties.component.html',
	styles: [
		`
			:host {
				display: flex;
				height: 100%;
			}
		`,
	],
	standalone: false,
})
export class PartiesComponent {
	testHooks = TestHooks;
}
